import { cn } from "@/lib/utils";
import Image from "next/image";

export interface AccreditationValueCircleItem {
  id: string;
  meta_image?: string;
  meta_alt_image?: string;
  meta_heading?: string;
  meta_description?: string;
}

const AccreditationValueCircle = ({
  item,
  stackIndex,
  className,
}: {
  item: AccreditationValueCircleItem;
  stackIndex: number;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "relative flex h-[197px] w-[197px] shrink-0 flex-col items-center justify-center gap-2 overflow-hidden rounded-full",
        /* Reference OurValueCard overlap: mobile vertical (-12px top), desktop horizontal (-24px left) */
        "-mt-3 min-[1024px]:mt-0 min-[1024px]:-ml-6",
        className
      )}
      style={{ zIndex: 10 + stackIndex }}
    >
      {item.meta_image ? (
        <Image
          src={item.meta_image}
          alt={item.meta_alt_image || item.meta_heading || "Value"}
          width={197}
          height={197}
          className="absolute z-0 h-full w-full object-cover"
        />
      ) : (
        <div className="absolute inset-0 z-0 bg-neutral-400" aria-hidden />
      )}

      {/* Reference bg-gradient-dark: flat 61% black overlay */}
      <div
        className="absolute inset-0 z-[1]"
        style={{ backgroundColor: "rgba(0,0,0,0.61)" }}
        aria-hidden
      />

      <div className="relative z-[2] flex flex-col items-center justify-center gap-2 text-center text-white">
        {item.meta_heading ? (
          <h3 className="overflow-hidden text-[18px] font-semibold leading-normal min-[1024px]:h-7">
            {item.meta_heading}
          </h3>
        ) : null}
        {item.meta_description ? (
          <p className="h-12 w-[117px] text-xs font-normal leading-normal min-[1024px]:w-auto min-[1024px]:text-[16px] min-[1024px]:tracking-[-0.03em]">
            {item.meta_description}
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default AccreditationValueCircle;
